import StyledRating from '@mui/material/Rating'
import { ratingValue } from '../utilities/fieldData';

export const IndividualReviewGroup = ({groupName, groupKey, review}) => {
    const value = ratingValue(review[groupKey]);

    if (value === undefined) {
        return null;
    }

    return (
        <div className="individual-review-group">
            <p>{groupName}</p>
            <StyledRating
                    className="individual-review-group-rating"
                    name="field-rating"
                    defaultValue={value}
                    value={value}
                    precision={0.5}
                    icon={<img alt="Rated" src="/rating-gold.svg" />}
                    emptyIcon={<img alt="Not rated" src="/rating-off.svg" />}
                    readOnly
                />
        </div>
    );
}

export const Review = ({review}) => {
    return (
        <div className="individual-review">
            <hr/>
            <p className="reviewer">{review.reviewer_full_name}</p>
            <IndividualReviewGroup groupName="Overall" groupKey="overall" review={review} />
            <IndividualReviewGroup groupName="Infield" groupKey="infield" review={review} />
            <IndividualReviewGroup groupName="Outfield" groupKey="outfield" review={review} />
            <IndividualReviewGroup groupName="Surrounding Area" groupKey="surrounding" review={review} />
            <p className="review-content">{review.text}</p>
        </div>
    )
}
